import React, { createContext, useCallback, useMemo, useRef } from 'react';

import { sendPostMessageToIFrame } from 'helpers/iframe';

export const PaymentContext = createContext<{
  paymentIframeRef: React.RefObject<HTMLIFrameElement>;
  sendMessageToIframe: (msg: any) => void;
}>({
  paymentIframeRef: { current: null },
  sendMessageToIframe: () => {},
});

export const PaymentProvider: React.FC = ({ children }) => {
  const paymentIframeRef = useRef<HTMLIFrameElement>(null);

  const handleSendPostMessage = useCallback((msg: any) => {
    if (paymentIframeRef.current) {
      sendPostMessageToIFrame(paymentIframeRef.current, msg);
    }
  }, []);

  const value = useMemo(
    () => ({ paymentIframeRef, sendMessageToIframe: handleSendPostMessage }),
    [paymentIframeRef, handleSendPostMessage]
  );

  return (
    <PaymentContext.Provider value={value}>{children}</PaymentContext.Provider>
  );
};
